import { LoadingButton } from '@mui/lab';
import { buttonClasses } from '@mui/material/Button';
import { styled } from '@mui/material';

const StyledAppbarSecondaryLoadingButton = styled(LoadingButton)(({ theme }) => ({
  background: 'transparent',
  // Mode-aware: borde/texto del tema (negro en claro, blanco en oscuro).
  borderColor: theme.palette.text.primary,
  color: theme.palette.text.primary,
  fontSize: theme.typography.pxToRem(14),
  padding: '6px 16px',
  textTransform: 'none',
  '&:hover': {
    background: 'transparent',
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main
  },
  [`&.${buttonClasses.disabled}`]: {
    borderColor: theme.palette.grey[600]
  }
}));

export default StyledAppbarSecondaryLoadingButton;
